"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@mui/material/styles");
var _Tooltip = _interopRequireWildcard(require("@mui/material/Tooltip"));
const _excluded = ["className", "placement"],
  _excluded2 = ["title", "text", "children", "type", "backgroundColor"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const NormalTooltip = (0, _styles.styled)(_ref => {
  let {
      className,
      placement = 'top'
    } = _ref,
    _props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, _extends({}, _props, {
    arrow: true,
    classes: {
      popper: className
    },
    placement: placement
  }));
})(p => ({
  ["& .".concat(_Tooltip.tooltipClasses.arrow)]: {
    color: (p === null || p === void 0 ? void 0 : p.color) || 'var(--main-color-cl-02)',
    margin: '0'
  },
  ["& .".concat(_Tooltip.tooltipClasses.tooltip)]: {
    fontWeight: 'bold',
    backgroundColor: (p === null || p === void 0 ? void 0 : p.color) || 'var(--main-color-cl-02)',
    borderRadius: '5px'
  }
}));

/**
 * @class TooltipWrap
 *
 * @param {any} props.title Tooltip title
 * @param {any} props.children
 * @param {string} props.type Type of styles for tooltip
 * @param {string} props.backgroundColor Background color
 * @param {Object} props.muiProps Other params for Tooltip (by documentation)
 *
 * @return {JSX.Element}
 * @constructor
 */
const TooltipWrap = props => {
  const {
      title,
      text,
      // !!!! OLD !!!!!
      children,
      type = 'normal',
      // 'normal', 'default'
      backgroundColor = 'var(--main-color-cl-02)'
    } = props,
    muiProps = _objectWithoutProperties(props, _excluded2);
  const getStyledTooltip = (0, _react.useCallback)(() => {
    switch (type) {
      case 'normal':
        return NormalTooltip;
      case 'default':
      default:
        return _Tooltip.default;
    }
  }, [type, NormalTooltip]);
  const StyledTooltip = getStyledTooltip();
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(StyledTooltip, _extends({
    title: title || text,
    color: backgroundColor
  }, muiProps), children), [children, title, text, backgroundColor, ...Object.values(muiProps || {})]);
};
var _default = exports.default = TooltipWrap;